<template>
    <div class="table-responsive">
        <table class="table table-hover no-overflow">
            <thead>
                <tr>
                    <th @click="$emit('sort', 'referenceNumber')">
                        Folios
                        <span v-if="creditFacilitieStore.sortKey === 'referenceNumber'">
                            <i
                                :class="creditFacilitieStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="emit('sort', 'prospectus.referenceNumber')">
                        Folios de Prospectos
                        <span v-if="creditFacilitieStore.sortKey === 'prospectus.referenceNumber'">
                            <i
                                :class="creditFacilitieStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="emit('sort', 'loanApplication.referenceNumber')">
                        Folios de Solicitudes
                        <span v-if="creditFacilitieStore.sortKey === 'loanApplication.referenceNumber'">
                            <i
                                :class="creditFacilitieStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'nameProspect')">
                        Nombre(s)
                        <span v-if="creditFacilitieStore.sortKey === 'nameProspect'">
                            <i
                                :class="creditFacilitieStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'prospectus.personType.name')">
                        Tipo de persona
                        <span v-if="creditFacilitieStore.sortKey === 'prospectus.personType.name'">
                            <i
                                :class="creditFacilitieStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'status.name')">
                        Estatus
                        <span v-if="creditFacilitieStore.sortKey === 'status.name'">
                            <i
                                :class="creditFacilitieStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'createdAt')">
                        Fecha de creación
                        <span v-if="creditFacilitieStore.sortKey === 'createdAt'">
                            <i
                                :class="creditFacilitieStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'receiptPaymentFiles.updatedAt')">
                        Fecha de actualización
                        <span v-if="creditFacilitieStore.sortKey === 'receiptPaymentFiles.updatedAt'">
                            <i
                                :class="creditFacilitieStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="list.length > 0">
                    <tr v-for="creditFacility in list" :key="creditFacility.id">
                        <td>{{ creditFacility.referenceNumber }}</td>
                        <td>{{ creditFacility.prospectus.referenceNumber }}</td>
                        <td>{{ creditFacility.loanApplication.referenceNumber }}</td>
                        <td>{{ getName(creditFacility) }}</td>
                        <td>{{ creditFacility.prospectus.personType.name }}</td>
                        <td>{{ creditFacility.status.name }}</td>
                        <td>{{ $filters.formatDate(creditFacility.createdAt) }}</td>
                        <td>{{ $filters.formatDate(creditFacility.receiptPaymentFiles.updatedAt) }}</td>
                        <td>
                            <PrimaryButton class="btn-success" @click="$emit('edit', creditFacility)"
                                data-toggle="modal" data-target="#modal-lg">
                                <i class="fa fa-edit"></i>
                            </PrimaryButton>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="8" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import { useCreditFacilities } from '@/pinia/creditFacilities.module';
import { getCurrentInstance } from 'vue';

const props = defineProps({
    list: {
        type: Array,
        required: true,
        default: () => []
    }
});

/**
 * Abre el modal para editar un registro de disposición
 * Acción por el boton de la tabla
 */
const emit = defineEmits(['sort', 'edit']);
const creditFacilitieStore = useCreditFacilities();

// Acceder a las propiedades globales
const instance = getCurrentInstance();
const $filters = instance?.appContext.config.globalProperties.$filters;

const getName = (item) => {
    if (item.prospectus.generalInformation.businessName === null) {
        return `${item.prospectus.generalInformation.firstName} ${item.prospectus.generalInformation.lastName} ${item.prospectus.generalInformation.mothersMaidenName}`;
    } else {
        return `${item.prospectus.generalInformation.businessName}`;
    }
}
</script>